import {PROJECT_BASE_PATH} from '../workspace/multiRunWorkspacePaths';

const ENTITY_LAUNCH_BASE = '/:entityName/launch';

export const ENTITY_LAUNCH_PATHS = [
  '/launch/',
  ENTITY_LAUNCH_BASE,
  '/launch/agents',
  `${ENTITY_LAUNCH_BASE}/agents`,
  '/launch/resources',
  `${ENTITY_LAUNCH_BASE}/resources`,
];
export const AGENT_PATHS = [
  `${ENTITY_LAUNCH_BASE}/agents/:agentId`,
  `${ENTITY_LAUNCH_BASE}/agents/:agentId/:tab`,
];
export const QUEUE_PATHS = [
  `${ENTITY_LAUNCH_BASE}/:queueId`,
  `${ENTITY_LAUNCH_BASE}/:queueId/:tab`,
];

export const PROJECT_LAUNCH_TAB_PATH = `${PROJECT_BASE_PATH}/:tab(launch)/:launchTab?`;

export const PROJECT_JOB_PATH = `${PROJECT_BASE_PATH}/:tab(jobs)/:jobId`;
export const PROJECT_JOB_TAB_PATH = `${PROJECT_BASE_PATH}/:tab(jobs)/:jobId/:jobTab(runs|job_details|version_details)/:jobVersion?`;
export const PROJECT_JOB_PATHS = [PROJECT_JOB_PATH, PROJECT_JOB_TAB_PATH];
